import { render, staticRenderFns } from "./PayPartsOrderPage.vue?vue&type=template&id=520f10a8&"
import script from "./PayPartsOrderPage.vue?vue&type=script&lang=js&"
export * from "./PayPartsOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports